import styled from '@emotion/styled';
import { Grid } from '@material-ui/core';
import { Magnetic } from '@mitchell/react.component.ux';
export const StyledRecursiveRenderer = styled('div', {
    shouldForwardProp: prop => prop !== 'isBottomMargin'
})((props) => `
	padding-bottom: ${props.isBottomMargin ? Magnetic.spacer16 : 0};
`);
export const StyledNoPhotosWrapper = styled(Grid) `
	display: inline-block;
	width: 100%;
	background-color: transparent;
`;
export const StyledNoPhotosContent = styled('div') `
	height: ${Magnetic.spacer96};
	font-size: ${Magnetic.fontSize16};
	color: ${Magnetic.colorNeutral50};
	display: flex;
	align-items: center;
	justify-content: center;
`;
//# sourceMappingURL=AlbumHierarchyComponent.style.js.map